import anime from "animejs";

export default {
    name: 'scribbles',
    component() {
        return {
            // unScribble(id) {
            //     const path = this.$root.querySelectorAll(`#writing-${id} path`)[0];
            //     let pathLength = path.getTotalLength();
            //     path.setAttribute('stroke-dasharray', pathLength);

            //     anime({
            //         targets: path,
            //         strokeDashoffset: [0, pathLength],
            //         easing: 'easeInOutCubic',
            //         duration: 500,
            //         // delay: function(el, i) { return i * 250 },
            //         direction: 'normal',
            //         loop: false
            //       });
            // },

            // reScribble(id) {
            //     const path = this.$root.querySelectorAll(`#writing-${id} path`)[0];
            //     let pathLength = path.getTotalLength();
            //     path.setAttribute('stroke-dasharray', pathLength);

            //     anime({
            //         targets: path,
            //         strokeDashoffset: [pathLength, 0],
            //         easing: 'easeInOutCubic',
            //         duration: 500,
            //         // delay: function(el, i) { return i * 250 },
            //         direction: 'normal',
            //         loop: false
            //       });
            // },

        }
    }
}